export default {
    fund: [{
            "title": "投资者教育和风险揭示工作必须有机融入到基金管理人的各项业务流程，具体体现在客户服务体系的各个环节中，下列表述正确的是（　　）。",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. II、III、IV\nD. I、III、IV",
            "questions": "I. 在开户环节看风险揭示，向客户讲解有关业务合同、协议，明示投资风险，并由客户在风险揭示书上签字确认<br>II. 在进行产品推荐时，应当清楚说明不同产品的区别以提高投资者的投资收益<br>III. 向客户明确说明公司的法律业务范围，帮助投资者提高判断能力<br>IV. 通过适当的方法了解不同的客户，引导投资者从风险承担能力等自身实际情况出发，合理配置金融资产",
            "answer": "D",
            "explain": "本题考查基金客户服务的流程。II项说法错误，在进行产品推荐时，与投资者说清楚产品的区别，并不是为了提高投资者的收益，而是遵守销售适用性原则的体现。",
        }, {
            "title": "基金公司管理层应始终放在首要地位并作出承诺的是（　　）。",
            "question": "A. 风险管理\nB. 投资收益\nC. 公司信誉\nD. 股东利益",
            "answer": "A",
            "explain": "本题考查风险管理的原则。风险管理作为公司的标志与文化，代表着公司管理层对基金投资者的承诺，公司管理层应始终把风险控制放在经营管理的首要地位并对此做出承诺。故本题选A选项。",
        }, {
            "title": "关于基金合同，以下表述错误的是（　　）。",
            "question": "A. 基金合同中约定基金份额持有人可对基金管理人、托管人或基金份额发售机构损害其合法权益的行为依法提起诉讼\nB. 基金合同应当明确约定持有人大会的召开、议事规则等事项\nC. 基金合同包含基金投资运作安排和基金份额发售安排方面的信息\nD. 基金合同一旦终止，基金财产就进入清算程序，对于清算后的基金财产，基金管理人享有部分分配权",
            "answer": "D",
            "explain": "",
        }, {
            "title": "关于基金的托管，以下表述正确的是（　　）。",
            "question": "A. 基金托管人作为共同受托人对基金投资人的投资运作负有监督职责\nB. 公募基金和私募基金都必须进行托管\nC. 私募基金满足特定条件可以不进行托管\nD. 公募基金满足特定条件可以不进行托管",
            "answer": "C",
            "explain": "本题考查对非公开募集基金运作的监管。基金托管制度是规范基金运作、保护基金投资者合法权益的一项重要制度，基金托管人作为共同受托人对基金管理人的投资运作负有监督职责。(A选项错误)",
        }, {
            "title": "以下不属于基金管理公司管理层下设的风险管理委员会职责的是（　　）。",
            "question": "A. 指导、协调和监管各职能部门和各业务单元开展风险管理工作\nB. 重点关注内控机制薄弱环节和可能给公司带来重大损失的事件，提出控制措施和解决方案\nC. 制定相关风险控制政策，审批风险管理重要流程和风险敞口管理体系\nD. 每日监控风险敞口，对风险管理决策和风险管理制度执行情况进行日常检查，评估和报告",
            "answer": "D",
            "explain": "本题考查风险管理委员会的职责。为协助管理层履行风险管理职能，公司管理层下可以设立履行风险管理职能的委员会，风险管理委员会对管理层负责，协助管理层履行以下职责：",
        }, {
            "title": "关于投资者保护工作，以下表述错误的是（　　）。",
            "question": "A. 投资者保护的手段是用简单的语言向投资者解释他们在投资过程中面临的问题和应对措施\nB. 基金行业的参与主体都需要积极开展投资者保护工作\nC. 投资者保护是证券监管的目标之一\nD. 投资者保护的目标是确保投资者不发生亏损",
            "answer": "D",
            "explain": ""
        }, {
            "title": "以下符合基金公司内部控制目标的是（　　）。",
            "question": "A. 督察长兼任财务负责人，更好的防范和化解经营风险\nB. 制定防范风险的奖惩制度，对风险事件处理不当的相关责任人采取惩罚措施\nC. 鼓励基金经理通过媒体向公众推荐股票，提升公司知名度\nD. 合并信息技术部和监察稽核部，确保财务信息和其他信息准确",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "ETF基金管理人应于（　　）向证券交易所、证券登结算机构提供ETF的申购清单和赎回清单。",
            "question": "A. 每日开市前\nB. 每日收盘前15分钟\nC. 每日开市后\nD. 每日收盘后15分钟",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "某基金经理的下列行为违反诚实守信要求的是（　　）。",
            "question": "A. 目标公司股票市值小，当发现有大的同业基金进入时，就打压股价，等对方卖出时再低价买入\nB. 在公开论坛上，使用自己的微博大V账号发表目标公司的收入趋势分析\nC. 参加目标公司相关公开活动，关注目标公司高管的公开访谈，依据收集的公开信息进行投资决策\nD. 目标公司股票高度集中，流通股票比例少，股价较低，于是大量买入以待股价高涨",
            "answer": "A",
            "explain": "本题考查诚实守信。A选项符合题意，违反了诚实守信要求中的不得操纵市场。基金从业人员不得通过操纵市场牟取不正当利益，不得利用资金优势，持股优势和信息优势，单独或者合谋串通，影响证券交易价格或交易量，误导和干扰市场。"
        },
        {
            "title": "以下不属于中国证券投资基金业协会职责的是（　　）。",
            "question": "A. 教育和组织会员遵守有关证券投资的法律、行政法规，维护投资人合法权益\nB. 依法办理非公开募集基金的登记、备案\nC. 制定有关证券投资基金活动监督管理规则，并行使审批、核准或者注册权\nD. 制定和实施行业自律规则，监督、检查会员及其从业人员的职业行为，对违反自律规则和协会章程的，按照规定给予纪律处分",
            "answer": "C",
            "explain": "本题考查基金业协会的职责。基金业协会的职责包括：（1）教育和组织会员遵守有关法律法规、行政法规、维护投资人合法权益(A项正确)"
        },
        {
            "title": "甲基金管理公司拟发售A基金份额，该基金托管在取得基金托管资格的乙银行，乙商业银行应于基金份额发售3日前将（　　）登载在其官方网站",
            "question": "A. I、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、III",
            "questions": "I. 基金合同<br>II. 基金份额发售公告<br>III. 托管协议<br>IV. 招募说明书",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金销售机构，以下情形合规的是（　　）。",
            "question": "A. 某银行未取得基金销售资格，通过其手机APP销售基金\nB. 某证券公司未取得基金销售资格，通过将基金公司直销平台接入其内部系统销售基金\nC. 某基金管理公司自行开发建立电子商务平台，销售全市场基金产品\nD. 某基金管理公司建立机构销售团队，向机构投资者直销其基金产品",
            "answer": "D",
            "explain": "本题考查基金销售机构的销售方式。直销机构是指直接销售基金的基金公司。基金公司开展直销目前主要包括两种形式：（1）专门的销售人员直接开发和维护机构客户和高净值个人客户。(D选项正确)"
        }, {
            "title": "关于合规管理对基金公司运营的意义，以下表述错误的是（　　）。",
            "question": "A. 降低重大财务损失的风险\nB. 降低声誉损失的风险\nC. 减少违规处罚\nD. 有利于基金管理公司利润最大化",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "以下哪个主体不能成为基金管理人（　　）。",
            "question": "A. 股权公司\nB. 有限责任公司\nC. 合伙企业\nD. 社会团体法人",
            "answer": "D",
            "explain": "本题考查基金管理人的市场准入监管。依据《证券投资基金法》的规定，基金管理人由依法设立的公司或者合伙企业(C选项不符合题意)担任。而担任公开募集基金的管理人的主体资格受到严格限制，只能由基金管理公司或者经证监会按照规定核准的其他机构担任。"
        },
        {
            "title": "以下投资者可以买卖上市交易的封闭式基金的是（　　）。",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、IV",
            "questions": "I. 开立了沪、深证券账户和沪、深基金账户及资金账户的投资者<br>II. 开立了沪、深基金账户和资金账户，未开立沪、深证券账户的投资者<br>III. 开立了沪、深证券账户和资金账户，未开立沪、深基金账户的投资者<br>IV. 开立了沪、深证券账户和沪、深基金账户，未开立资金账户的投资者",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于基金销售渠道的审慎调查，以下行为错误的是（　　）。",
            "question": "A. 某商业银行总行个人金融部建立了科学、客观的基金管理人筛选机制，建立合作白名单，对每个拟上线基金管理人均进行打分\nB. 某银行分行零售部门根据私下对某产品基金经理的调研，结合对该基金公司、产品的综合调查、评价，决定重点推介该产品\nC. 某地方银行行长向某基金公司总经理表示，虽然其合规销售人员少，信息平台建设落后，但销售能力强，该基金公司直接上线该产品\nD. 某互联网基金销售平台要求基金管理人提供近三年的财务报表，以便于其审查、筛选基金管理人",
            "answer": "C",
            "explain": "本题考查基金销售渠道审慎调查。基金销售的适用性要求基金管理人和基金代销机构相互进行审慎调查。基金销售渠道审慎调查主要包括以下方面：（1）基金代销机构通过对基金管理人进行审慎调查(D选项符合审慎调查要求);"
        },
        {
            "title": "以下属于基金管理中的内幕交易行为的是（　　）。",
            "question": "A. 基金经理根据研究员在实地调研报告载明的某上市公司员工人数增长率，推测该上市公司产能和业绩增长情况，据以开仓\nB. 基金经理为提升其管理的基金所重仓持有的股票价格，通过网络论坛捏造并散布该上市公司即将重大重组的消息\nC. 研究员汇总网络论坛、微博等媒体传言，形成对本年度该上市公司分红的书面预测\nD. 基金经理与上市公司董事会秘书沟通获悉上市公司定向增发申请未获证监会核准后，在上市公司进行信息披露前，卖出",
            "answer": "D",
            "explain": "本题考查内幕交易。内幕交易，是指利用内幕信息进行证券交易，以为自己或者他人牟取利益。内幕信息的构成要素有三：一是来源可靠的信息、该信息对证券价格的影响明确，三是公开的信息。"
        },
        {
            "title": "A基金管理公司决定与各类销售机构广泛合作，开展相关促销活动，在合作前，按制度对各家销售基金的销售机构核，以下不属于基金销售适用性管理制度的组成内容的是（　　）。",
            "question": "A. 基金投资人风险承受能力调查和评估的方式和方法\nB. 基金产品风险评价的方式和方法\nC. 基金产品和基金投资人进行匹配的方法\nD. 基金产品绩效归因的方式和方法",
            "answer": "D",
            "explain": "本题考查基金销售机构适用性的管理制度。基金销售机构适用性的管理制度包括：（1）对基金管理人进行审慎调查的方式和方法；"
        }, {
            "title": "基金管理公司的风险管理主要包括哪些环节（　　）。",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、III、IV\nD. II、III、IV",
            "questions": "I. 风险识别、风险评估II. 风险应对III. 风险报告和监控IV. 风险管理体系的评价",
            "answer": "B",
            "explain": "本题考查风险管理内容。基金管理公司风险管理的主要环节有：风险识别、风险评估、风险应对、风险报告和监控、风险管理体系的评价。"
        },
        {
            "title": "基金管理人内部控制包括的基本要素有（　　）。",
            "question": "A. I、II、IV、V、VI\nB. II、IV、V、VI\nC. I、II、III、IV、V\nD. II、III、IV、V",
            "questions": "I. 内部监控<br>II. 控制环境<br>III. 控制成本<br>IV. 控制活动<br>V. 风险评估<br>VI. 信息与沟通",
            "answer": "A",
            "explain": "本题考查风险管理内容。基金管理人内部控制包括的基本要素有：内部监控、控制环境、控制成本、控制活动、风险评估、信息与沟通。"
        },
        {
            "title": "关于私募基金的推介方式，以下符合法规规定的是（　　）。",
            "question": "A. 通过报刊、电视台推介\nB. 通过分析会、报告会向特定对象推介\nC. 向公众群发邮件、短信推介\nD. 通过广告宣传推介",
            "answer": "B",
            "explain": "本题考查私募基金宣传推介的禁止渠道。私募基金不得公开宣传，因此募集机构不得通过下列媒介渠道推介私募基金：（1）公开出版资料；（2）面向社会公众的宣传单、布告、手册、信函、传真；（3）海报、户外广告。"
        },
        {
            "title": "公开募集基金的基金管理人内部治理结构不符合规定且逾期未改正的，中国证监会有权对其采取监管措施是（　　）。",
            "question": "A. 限制转让基金财产或者在基金财产上设定其他权利\nB. 对董事、监事、高级管理人员处以罚款\nC. 限制业务活动，责令暂停部分或者全部业务\nD. 没收有关股东的股权及红利",
            "answer": "C",
            "explain": "本题考查对基金管理人的监管。公募基金管理人违法违规的，或内部治理结构等不符合规定且逾期未改正的，中国证监会可采取下列限制措施："
        },
        {
            "title": "基金合同生效日是指（　　）。",
            "question": "A. 法定验资机构完成验资之日\nB. 基金募集期限届满之日\nC. 中国证监会书面确认之日\nD. 提交备案申请和验资报告之日",
            "answer": "C",
            "explain": "本题考查基金的合同生效。中国证监会自收到基金管理人验资报告和基金备案材料之日起3个工作日内予以书面确认；自中国证监会书面确认之日起，基金合同生效。"
        },
        {
            "title": "投资者于交易日申购某开放式基金，申购金额5万元，申购手续费500元。申购当日基金份额净值为1.012元，1日的有效申购份额为（　　）。",
            "question": "A. 48913.04\nB. 49500.00\nC. 49058.47\nD. 48907.11",
            "answer": "A",
            "explain": ""
        }, {
            "title": "某基金管理人拟成立有限合伙型私募股权投资基金，拟募集金额50亿元，预计投资者数量较多。该基金管理金进行托管，对此，以下表述正确的是（　　）。",
            "question": "A. 该基金规模较大且投资者人数较多，因此基金管理人必须对该基金进行托管\nB. 基金管理人和基金投资人可以在合同中约定对该私募基金不进行托管，但必须事先取得中国证券投资基金业协会认可\nC. 基金管理人可自行决定不对该基金进行托管，但节省托管费用不是充分理由\nD. 基金管理人和基金投资人可以在合同中明确约定该基金不进行托管，但必须同时明确保障私募基金财产安全",
            "answer": "D",
            "explain": "本题考查非公开募集基金的托管。A项表述错误《证券投资基金法》允许非公开募集基金的当事人对于设置基金托管人做例外约定，即非公开募集基金当事人可以约定不设基金托管人。"
        },
        {
            "title": "在信息披露的内容方面，要求遵循的原则包括（　　）。",
            "question": "A. I、II、III、IV\nB. II、III、IV\nC. I、II、IV\nD. I、III、IV",
            "questions": "I. 真实性<br>II. 准确性<br>III. 预测性<br>IV. 完整性",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "私募基金管理人自行销售私募基金的，投资者签署的文件不应当包括（　　）。",
            "question": "A. 投资说明书\nB. 投资者风险识别能力和风险承担能力的调查问卷\nC. 风险揭示书\nD. 投资者符合合格投资者条件的承诺函",
            "answer": "A",
            "explain": "本题考查对私募基金募集行为的监管。私募基金管理人自行销售私募基金的，应当采取问卷调查等形式，对投资者的风险识别能力和风险承担能力进行评估，由投资者书面承诺。"
        },
        {
            "title": "关于基金管理人信息技术系统控制，以下说法正确的是（　　）。",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、III、IV",
            "questions": "I. 基金管理信息技术系统的设计开发应该符合国家、金融行业软件工程标准的要求，编写完整的技术资料<br>II. 在实现业务电子化时，应设立保密系统和相应控制机制，并保证计算机系统的可稽性<br>III. 信息技术系统投入运作前，应当经过业务运营、监察、稽核等部门的联合验收<br>IV. 应当通过严格的岗位责任制度、门禁制度、内外网分离制度等管理措施，确保系统安全运行。",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "投资人可以到以下机构认购开放式基金（　　）。",
            "question": "A. II、III、IV\nB. I、III、IV\nC. I、II、III、IV\nD. I、II、III",
            "questions": "I. 信托公司<br>II. 证券公司<br>III. 期货公司<br>IV. 保险机构",
            "answer": "A",
            "explain": ""
        }, {
            "title": "偏离度达到（　　）时要进行临时报告的披露。",
            "question": "A. 偏离度的绝对值达到0.5%\nB. 负偏离度达到0.25%\nC. 正偏离度达到0.25%\nD. 偏离度的绝对值达到0.25%",
            "answer": "A",
            "explain": "本题考查货币市场基金偏离度公告。D选项正确，当影子定价和摊余成本法确定的基金资产净值偏离度的绝对值达到或者超过0.5%时，基金管理人将在事件发生之日进行临时报告。"
        },
        {
            "title": "下列关于基金交易业务控制的说法正确的是（　　）。",
            "question": "A. 基金交易应实行直接交易制度\nB. 基金经理可直接进行交易\nC. 基金经理不可直接向交易员下达投资指令或者直接进行交易\nD. 基金经理可直接向交易员下达投资指令",
            "answer": "C",
            "explain": "本题考查基金交易业务控制。A选项说法错误，基金交易应实行集中交易制度，而不是直接交易。"
        },
        {
            "title": "关于基金募集失败的认定及管理人应当承担的责任，以下表述正确的是（　　）。",
            "question": "A. I、II、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、III、IV",
            "questions": "I. 封闭式基金募集的基金份额未达到核准规模的80%以上，基金募集失败<br>II. 基金募集失败, 基金管理人应承担因募集行为而产生的债务和费用<br>III. 包含发起式基金的开放式基金,募集总份额少于2亿份或者份额持有人少于200人,基金募集失败<br>IV. 基金募集失败，基金管理人应在基金募集期限届满后30日内返还投资者已缴纳的款项，并加计银行同期存款利息",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于基金销售机构对普通投资者和专业投资者销售产品和提供服务，以下表述正确的是（　　）。",
            "question": "A. 根据业务资格、投资实力、投资经历等因素,对专业投资者进行细化分类和管理\nB. 对普通投资者分类,并向其主动推介高于其风险承受能力的产品\nC. 定期跟踪调整,将符合转化条件的普通投资者转化为专业投资者\nD. 对专业投资者发出的转化为普通投资者的书面告知予以严格审查，并自主决定是否同意其转化",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于基金管理人合规管理的独立性原则，以下表述错误的是（　　）。",
            "question": "A. 合规部门在基金公司组织体系中应当有独立性\nB. 职工监事在基金公司组织体系中应当有独立性\nC. 合规管理应当独立于其他各项业务经营活动\nD. 督察长在基金公司组织体系中应当有独立性",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "在基金开始募集前，基金管理人需要公告的事项包括（　　）。",
            "question": "A. I、II、IV\nB. I、III、IV\nC. I、II、III\nD. II、III、IV",
            "questions": "I. 招募说明书<br>II. 基金合同及摘要<br>III. 基金份额发售公告<br>IV. 基金合同生效公告",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "普通基金净值公告主要包括（　　）。",
            "question": "A. I、III、IV\nB. I、II、IV\nC. II、III、IV\nD. I、II、III",
            "questions": "I. 基金资产净值<br>II. 基金份额净值<br>III. 基金份额累计净值<br>IV. 基金总资产",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于投资者教育，以下描述正确的是（　　）。",
            "question": "A. II、III\nB. I、II\nC. III、IV\nD. II、III、IV",
            "questions": "I. 在制定投资者教育策略时，首先致力于普及投资专业技能<br>II. 投资者决策教育是投资者教育体系的基础<br>III. 资产配置教育是投资者对个人资产的科学计划和控制<br>IV. 权益保护教育不是市场化的要求",
            "answer": "A",
            "explain": ""
        }, {
            "title": "某公司型基金自聘管理团队甲、乙、丙担任管理基金资产，关于该公司型基金的备案登记，以下说法正确的是（　　）。",
            "question": "A.该公司型基金需要作为基金履行备案手续，自聘管理团队甲、乙、丙需要共同作为基金管理人履行登记手续\nB.该公司型基金应当作为基金履行备案手续，并作为基金管理人履行登记手续\nC.该公司型基金应当作为基金履行备案手续，不需要作为基金管理人履行登记手续\nD.该公司型基金应当作为基金管理人履行登记手续，不需要作为基金履行备案手续",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金管理人应当依法披露基金信息、公开披露的基金信息不包括（　　）。",
            "question": "A. 基金资产净值、基金份额净值\nB. 基金份额持有人大会决议\nC. 基金招募说明书、基金合同、基金托管协议\nD. 预期投资收益",
            "answer": "D",
            "explain": "本题考查基金管理人的信息披露义务。基金管理人主要负责办理与基金财产管理业务活动有关的信息披露事项，具体涉及："
        },
        {
            "title": "对公开募集证券投资基金募集的时间相关要求，以下表述正确的是（　　）。",
            "question": "A. II、III\nB. I、III\nC. III、IV\nD. I、II",
            "questions": "I. 基金管理人应当自收到准予注册文件之日起6个月内进行基金募集<br>II. 中国证监会应当自受理公开募集基金的募集注册申请之日起6个月内进行审查，做出决定并通知申请人<br>III. 基金管理人应当在基金份额发售的1日前公布招募说明书等法律文件<br>IV. 基金管理人应当自募集期限届满之日起1个月内聘请法定验资机构验资",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金管理人信息披露的行为，以下做法正确的是（　　）。",
            "question": "A. 可以在宏观和微观研究的基础上，对证券投资业绩进行谨慎性预测\nB. 可以告知投资人，基金管理人既不承诺最低收益，也不承诺保本\nC. 可以通过与同行的过往业绩对比来证明基金经理优秀的投资能力\nD. 可以登载符合要求的机构对基金的祝贺性文字",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金年度报告中的基金财务会计报告，以下表述错误的是（　　）。",
            "question": "A. 基金财务会计报告包括资产负债表及其附注\nB. 基金财务报表附注是对报表内未提供的或披露不详尽的内容作出进一步的解释说明\nC. 基金财务报表附注需要批注编制基金财务报表所采用的主要会计政策和会计估计，会计变更以及差错更正的说明\nD. 基金财务会计报表为报告期末的资产负债表，当年的利润表，当年的所有者权益变动表",
            "answer": "D",
            "explain": "本题考查基金年度报告。A选项表述正确，基金财务会计报告包括资产负债表及其附注。"
        },
        {
            "title": "下列关于职业道德的表述中，正确的是（　　）。",
            "question": "A. 职业素质仅指专业技能，不包括道德素养\nB. 职业道德素质差的人，也可能具有较高的业务能力，因此业务能力与职业道德没有什么关系\nC. 相对于业务能力，职业道德居次要地位\nD. 加强职业道德对业务能力的提高具有促进作用",
            "answer": "D",
            "explain": "本题考查职业道德。A选项表述错误，职业素质既包括专业技能，也包括道德素养。"
        },
        {
            "title": "某基金管理人资不抵债被法院宣告破产，以下属于破产清算财产的是（　　）。",
            "question": "A. 基金持有债券的利息\nB. 基金收回的结算备付金\nC. 基金应付的业绩报酬\nD. 基金取回的期货交易保证金",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于基金上市交易公告书的主要披露事项，以下表述错误的是（　　）。",
            "question": "A. 需要披露基金财务状况、基金投资组合报告\nB. 需要披露持有人户数、持有人结构和前5名持有人\nC. 需要披露基金概况、基金募集情况和上市交易安排\nD. 需要披露主要当事人情况、基金合同摘要",
            "answer": "B",
            "explain": "本题考查基金上市交易公告书的披露事项。基金上市交易公告书主要的披露事项包括："
        }, {
            "title": "A基金是一只普通开放式证券投资基金，于2016年成立。投资者甲于2017年2月7日上午10:00申购了A基金10150元，申购费率1.5%。A基金于2月6日至2月8日的基金份额净值如下所示:日期2月6日、2月7日和2月8日分别对应的基金份额净值为2.05、2.0和2.1。假设该笔申购成功，投资者甲可得到的A基金份额是（　　）。",
            "question": "A. 4878.05\nB. 4761.9\nC. 5000\nD. 5075",
            "answer": "C",
            "explain": "本题考查开放式基金申购份额、赎回金额的计算。"
        },
        {
            "title": "从业人员甲从基金管理公司离职时，带走了公司的客户清单，将这些客户清单交给新就职的基金管理公司用来拓展客户，甲的行为（　　）。",
            "question": "A. I、III、IV\nB. I、II、IV\nC. I、II、III\nD. II、III、IV",
            "questions": "I. 违反了忠诚尽责的职业道德规范<br>II. 违反了保守秘密的职业道德规范<br>III. 违反了专业审慎的职业道德规范<br>IV. 是一种不正当竞争行为",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "金融资产主要包含以下投资工具（　　）。",
            "question": "A. I、II\nB. I、II、III、IV\nC. II、III、IV\nD. I、II、III",
            "questions": "I. 票据<br>II. 债券<br>III. 股票<br>IV. 房地产",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于A基金销售机构基金销售适用性相关的制度和程序，以下表述错误的是（　　）。",
            "question": "A. 需要健全普通投资者的回访制度\nB. 总部已制定相关制度和程序，需要分支机构再自行制定相关的制度和程序\nC. 需要建立档案对销售人员进行管理\nD. 需要对销售人员进行专门的培训",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "开放式基金某一个开放日发生首次巨额赎回时，以下做法错误的是（　　）。",
            "question": "A. 巨额赎回且部分延期赎回的，管理人应立即向中国证监会备案\nB. 巨额赎回且部分延期赎回的，管理人在3个工作日内在至少一种中国证监会指定的信息披露媒体上公告说明有关处理办法\nC. 管理人可以暂停接受赎回申请\nD. 管理人可以接受全额赎回申请",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "基金管理人的基本管理制度一般包括（　　）。",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III\nD. I、II、III、IV",
            "questions": "I. 投资管理制度<br>II. 公司财务制度<br>III. 业绩考核制度<br>IV. 信息披露制度",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金管理人的内部控制机制建设，以下表述正确的是（　　）。",
            "question": "A. 除了按程序监督外，还需要注重对“内部人”的控制监督\nB. 在内部控制制度建立上，公司设立统一的内控制度，各部门无需再设单独的内控制度\nC. 为了提高公司运营效率，公司可以不设专职的内部控制部门\nD. 日常内部控制以对非经常性发生事项的控制为主，对经常性发生事项开展为辅",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "2017年7月4日，某销售机构对投资者小王进行了投资者风险评估，同日小王与该私募机构签订合同购买了与小王风险承受能力匹配的私募产品A，在随后的销告行为中，符合投资者适当性要求的是（　　）。",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III、IV\nD. II、III",
            "questions": "I. 2019年7月5日，如果该销售机构继续向小王推荐私募产品B，必须再对小王进行风险评估<br>II. 2020年7月5日，如果该销售机构继续向小王推荐私募产品B，必须再对小王进行风险评估<br>III. 2020年7月5日，如果小王要继续持有而不赎回私募产品A，该销售机构无需再对小王进行风险评估<br>IV. 2023年7月5日，如果小王要继续持有而不赎回私募产品A，该销售机构必须再对小王进行风险评估",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "扰乱市场正常秩序，侵害投资者合法权益的严重违法行为包括（　　）。",
            "question": "A. I、III\nB. II、III\nC. I、II、III\nD. I、II",
            "questions": "I. 虚假记载<br>II. 误导性称述<br>III. 重大遗漏",
            "answer": "C",
            "explain": ""
        }, {
            "title": "关于基金宣传推介材料原则性要求，以下表述正确的是（　　）。",
            "question": "A. III、IV\nB. I、II\nC. I、III、IV\nD. I、III",
            "questions": "I. 基金管理公司和基金销售机构都可以制作基金宣传资料<br>II. 基金销售机构制作某基金宣传推介材料，需要经过基金管理公司备案长审核签字方可宣传<br>III. 不可以对有悖基金合同约定的暂停、打开申购等营销手段进行宣传<br>IV. 在保证宣传内容合规性的前提下，向公众分发的基金宣传材料可以和提交备案的材料不一致",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "以下材料中，应当事先经基金经理人负责基金销售业务的高级管理人员和督察长检查，出具合规意见书的是（　　）。",
            "question": "A. 基金宣传推介材料\nB. 托管协议\nC. 基金合同\nD. 基金招募说明书",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "需要在基金定期报告的产品概况部分披露境外投资顾问和境外资产托管人的基金为（　　）。",
            "question": "A. QDII\nB. FOF\nC. MOM\nD. QFII",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "投资者教育是一项重要工作，也是一项长期的、基础性和常规性的工作，原因在于（　　）。",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III、IV\nD. I、II、III",
            "questions": "I. 法律法规在不断建立和健全<br>II. 金融产品和金融工具不断创新<br>III. 大量银行储户分流到证券市场<br>IV. 投资者存在非理性心理偏差",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "某公募证券投资基金拟披露2018年基金年度报告，基金管理人披露年度报告应当在（　　）之前。",
            "question": "A. 2018年12月31日\nB. 2019年3月31日\nC. 2019年1月31日\nD. 2019年4月30日",
            "answer": "B",
            "explain": "本题考查基金年度报告。基金管理人应在每年结束后90日内(B选项符合题意)，在指定报刊上披露年度报告摘要，在管理人网站上披露年度报告。"
        },
        {
            "title": "基金管理公司应实行逐级授权制度，以下说法错误的是（　　）。",
            "question": "A. 部门经理的权限由总经理授予\nB. 总经理的权限由股东会授予\nC. 基金经理对其管理基金的投资权限由基金合同授予\nD. 部门内人员的权限由部门经理授予",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "一般情况下，投资者T日转托管基金申请成功后，可于（　　）起赎回该部分基金份额。",
            "question": "A. T+3\nB. T+2\nC. T+1\nD. T",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金销售费用，以下表述正确的是（　　）。",
            "question": "A. 基金中期报告中应披露管理费中支付给基金销售机构的客户维护费总额\nB. 基金销售机构提取的客户维护费从基金销售服务费中列支\nC. 基金销售机构可以和基金管理人协议约定，按照交易量提取一定的客户维护费\nD. 对于不同的投资人，基金销售机构可以在基金招募说明书载明和公告之外，采用不同的费率",
            "answer": "A",
            "explain": "本题考查基金销售费用的具体规范。A选项表述正确，基金管理人应当在基金半年度报告和基金年度报告中披露从基金财产中计提的管理费、托管费、基金销售服务费的金额，并说明管理费中支付给基金销售机构的客户维护费总额。"
        },
        {
            "title": "对基金公司已经识别的风险点进行定性或者定量分析，或者利用定性和定量结合的方法进行分析，确定风险等级，以上表述是据风险管理程序中的（　　）。",
            "question": "A. 风险应对\nB. 风险识别\nC. 风险报告和监控\nD. 风险评估",
            "answer": "D",
            "explain": "本题考查风险评估的含义。风险管理是指基金公司围绕公司总体经营战略，识别潜在风险，制定风险应对策略，有效管理公司各环节风险的持续过程。"
        }, {
            "title": "某拟从事私募基金管理业务的公司向中国证券投资基金业协会申请私募基金管理人登记，应报送的信息至少包括（　　）。",
            "question": "A. 工商登记和营业执照正副本复印件、公司章程、主要股东名单、高级管理人员的基本信息\nB. 工商登记和营业执照正副本复印件、公司章程、所有股东名单、高级管理人员的基本信息\nC. 工商登记和营业执照正副本复印件、公司章程、主要股东名单、高级管理人员及基金经理的基本信息\nD. 工商登记和营业执照正副本复印件、公司章程、所有股东名单、高级管理人员及基金经理的基本信息",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "《证券投资基金销售管理办法》规定，基金宣传推介材料登载基金业绩的，备案文件应包括（　　）。",
            "question": "A. 代销机构出具的基金业绩复核函\nB. 基金托管人出具的基金业绩复核函\nC. 当地证监局出具的基金业绩复核函\nD. 基金份额登记机构出具的基金业绩复核函",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金公司在风险管理中应当遵循的原则包括（　　）。",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、II、III、IV\nD. I、II、IV",
            "questions": "I. 最高性原则<br>II. 适时性原则<br>III. 公正性原则<br>IV. 独立性原则",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金管理人的内部控制，以下说法错误的是（　　）。",
            "question": "A. 基金管理人内部控制能够确保投资者利益\nB. 基金管理人的内部控制应充分考虑内外部环境因素\nC. 基金管理人的内部控制效果与其内部控制体系和风险管理框架密切相关\nD. 基金管理人实施内部控制是为了防范和化解风险",
            "answer": "A",
            "explain": "本题考查基金管理人的内部控制。A选项说法错误，基金管理人内部控制是为了防范和化解风险，并不能确保投资者的利益。"
        },
        {
            "title": "投资者持有的基金份额变动需要经（　　）确认后才有效。",
            "question": "A. 基金销售机构\nB. 基金管理人\nC. 注册登记机构\nD. 基金托管人",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "根据法规要求，货币市场基金应披露每个开放日收益公告，以下披露内容正确的是（　　）。",
            "question": "A. 每万份基金净收益1.214亿元，最近7日年化收益率4.9141%\nB. 份额净值1.000元，偏离度0.0015%\nC. 份额净值1.000元，每万份基金累计收益1.1315元\nD. 份额净值1.000元，最近7日年化收益率4.4941%",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "甲是某基金公司基金经理，其同学乙喜欢炒股，在平时，甲常告诉同学乙其管理基金所投资的股票，甲的行为违反了职业道德中的（　　）要求。",
            "question": "A. II、III、IV\nB. I、II、III、IV\nC. I、III、IV\nD. I、II、III",
            "questions": "I. 守法合规<br>II. 专业审慎<br>III. 忠诚尽责<br>IV. 客户至上",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "在基金份额发售的3日前，需要在基金管理公司网站上公告的信息包含（　　）。",
            "question": "A. 基金合同、托管协议、募集申请报告\nB. 托管协议、招募说明书、募集申请报告\nC. 基金合同、托管协议、招募说明书\nD. 基金合同、招募说明书、募集申请报告",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "基金销售机构在进行产品销售时要注重销售的适用性，关于基金销售适用性，以下表述错误的是（　　）。",
            "question": "A. II\nB. II、III、IV\nC. II、IV\nD. I、II、III、IV",
            "questions": "I. 产品销售前应对客户进行风险评估<br>II. 产品选择应主要满足客户的盈利需求<br>III. 应根据投资者的风险承受能力推荐不同风险等级的产品<br>IV. 应向客户提供准确、完整的基金产品基本信息和特征",
            "answer": "A",
            "explain": ""
        }, {
            "title": "公开募集基金自（　　），基金备案手续办理完毕，基金合同生效。",
            "question": "A. 基金管理人公告之日起\nB. 中国证监会书面确认之日起\nC. 中国证监会书面确认次日起\nD. 中国证监会收到基金备案材料之日起",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "某基金管理公司的基金宣传推介材料中：“我司A基金将于今日发售，欲购从速，切莫错过申购良机”的不当表述体现在（　　）。",
            "question": "A. 片面宣传基金\nB. 虚假记载\nC. 片面强调集中营销时间\nD. 误导性陈述",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于LOF和ETF的申购和赎回，投资者甲认为，LOF和ETF都可以通过赎回操作，将基金份额转换为一篮子股票。投资者乙认为，ETF份额既可以通过申购，也可以通过二级市场买入得到，但LOF份额只能通过二级市场买入得到。关于两位投资者的观点，下列说法正确的是（　　）。",
            "question": "A. 甲、乙的观点都正确\nB. 甲的观点错误，乙的观点正确\nC. 甲、乙的观点都错误\nD. 甲的观点正确，乙的观点错误",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于“基金定投业务”宣传推介材料的制作，以下表述正确的是（　　）。",
            "question": "A. I、III、IV\nB. II、III、IV\nC. III、IV\nD. I、II、III、IV",
            "questions": "I. 仅可采用我国证券市场具有代表性的指数进行模拟<br>II. 应对过往足够长时间的实际收益率进行模拟，同时注明相应的复合年平均收益率<br>III. 应当说明模拟数据的来源、模拟方法及主要计算公式<br>IV. 应当说明模拟结果的不确定性",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金客户个性化服务的内容错误的是（　　）。",
            "question": "A. 承担为客户决策的责任\nB. 提供市场行情分析咨询，揭示市场风险\nC. 做好客户动态分析\nD. 加强客户沟通，了解客户深度需求",
            "answer": "A",
            "explain": "本题考查基金客户个性化服务。A选项错误，基金公司在市场行情分析中仅有提供信息咨询以及风险揭示的义务，不能承担客户决策的责任。"
        },
        {
            "title": "基金销售适用性管理制度应当至少包括以下内容（　　）。",
            "question": "A. I、II、III\nB. II、III\nC. I、II、III、IV\nD. II、III、IV",
            "questions": "I. 对基金管理人进行审慎调查的方式和方法<br>II. 对基金产品的风险等级进行设置<br>III. 对基金投资人风险承受能力进行调查和评价<br>IV. 对基金产品和基金投资人进行匹配的方法",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "某投资者赎回1000份某开放式基金份额，对应的赎回费率为0.5%，赎回日的基金份额净值为1.2500元，该投资者得到的净赎回金额是（　　）。",
            "question": "A. 1250元\nB. 1200元\nC. 1256.25元\nD. 1243.75元",
            "answer": "D",
            "explain": "本题考查赎回金额的确定。赎回总额=赎回数量×赎回日基金份额净值=1000×1.2500=1250元赎回费用=赎回总额×赎回费率=1250×0.5%=6.25元基金赎回金额=赎回总额-赎回费用=1250-6.25=1243.75元"
        },
        {
            "title": "以下不属于基金管理人内部控制原则的是（　　）。",
            "question": "A. 经济性原则\nB. 有效性原则\nC. 健全性原则\nD. 独立性原则",
            "answer": "A",
            "explain": "本题考查基金管理人内部控制的原则。基金管理人内部控制的原则有：健全性原则、有效性原则、独立性原则、相互制约原则、成本效益原则。A选项错误，经济性原则不属于基金管理人内部控制的原则。"
        },
        {
            "title": "以下属于基金管理人内部控制要求的是（　　）。",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、IV\nD. I、III、IV",
            "questions": "I. 部门设置体现权责明确、相互制约的原则<br>II. 公开、公平、公正原则<br>III. 强化内部监督稽核<br>IV. 建立完善岗位责任制度",
            "answer": "D",
            "explain": ""
        }, {
            "title": "关于违法失信信息，以下表述正确的是（　　）。",
            "question": "A. 违法失信信息在诚信档案中的效力为期限5年\nB. 因证券期货违法行为被市场禁入的信息效力期限为15年\nC. 超过效力期限的违法失信信息，不再进行诚信信息公开，但继续接受诚信信息申请查询\nD. 违法失信信息的效力期限自对违法失信行为的处理决定执行完毕之日起算",
            "answer": "D",
            "explain": "本题考查《证券期货市场诚信监督管理办法》相关规定。"
        },
        {
            "title": "基金从业人员在执业活动中应当对客户个人信息保密，以下选项中不属于基金从业人员在执业活动中应当保密的客户的隐私的是（　　）。",
            "question": "A. 客户家庭成员信息\nB. 客户的财务状况\nC. 客户的财务状况\nD. 客户违法行为信息",
            "answer": "D",
            "explain": "本题考查保守秘密。基金从业人员在执业活动中接触到的秘密主要包括以下三类：（1）商业秘密。是指不为公众所知悉的、能够带来经济利益、具有实用性并被采取保密措施的技术信息和经营信息。"
        },
        {
            "title": "关于开放式基金的认购，以下表述错误的是（　　）。",
            "question": "A. 开放式基金的认购采取份额认购的方式，即投资者在办理认购申请时是直接以认购数量提出申请\nB. 基金认购费用按认购金额的一定比例收取\nC. 投资者认购的最终结果要等基金募集期结束后才能确认\nD. 销售机构对认购申请的受理并不代表申请一定成功，而仅代表销售机构确实接受了认购申请",
            "answer": "A",
            "explain": "本题考查开放式基金的认购。A项说法错误，开放式基金的认购采取金额认购的方式，即投资者在办理认购申请时，不是直接以认购数量提出申请，而是以金额申请。"
        },
        {
            "title": "某私募基金管理人募集设立有限合伙型基金，关于基金备案，以下表述正确的是（　　）。",
            "question": "A. 私募基金募集完毕后，按有关规定向中国证券投资基金业协会备案\nB. 办理有限合伙企业工商注册之前，应当及时向中国证券投资基金业协会备案\nC. 私募基金募集完毕，私募基金投资完成后向中国证券投资基金业协会备案\nD. 办理有限合伙企业工商注册完毕，确定投资人之前，应当及时向中国证券投资基金业协会备案",
            "answer": "A",
            "explain": "本题考查非公开募集基金的备案。依据《证券投资基金法》的规定，非公开募集基金募集完毕，基金管理人应当向基金业协会备案。"
        },
        {
            "title": "关于非公开募集基金的托管，以下表述正确的是（　　）。",
            "question": "A. 基金托管人不得向基金份额持有人披露基金净值、投资收益分配、基金承担的费用和业绩报酬\nB. 与公开募集基金不同，除非基金合同另有约定，否则非公开募集基金无需托管\nC. 担任非公开募集基金的基金托管人应当按照规定向中国证券投资基金业协会履行登记备案手续，无需中国证监会核准\nD. 非公开募集基金的基金托管人应当按照规定向中国证券投资基金业协会履行登记备案手续，并需中国证监会核准",
            "answer": "C",
            "explain": "本题考查非公开募集基金的托管。A选项表述错误，《私募投资基金监督管理暂行办法》规定，私募基金管理人、私募基金托管人应当按照合同约定，如实向投资者披露投资策略、风险收益特征、投资收益分配、基金承担的费用和业绩报酬、可能存在的利益冲突情况以及可能影响投资者合法权益的其他重大信息，不得隐瞒或者提供虚假信息。"
        },
        {
            "title": "某基金公司在其门户网站上发布新基金宣传材料，关于此新基金的宣传材料，以下说法错误的是（　　）。",
            "question": "A. 该材料需要经营察长检查，出具合规意见书并报送监管部门\nB. 该材料内容应与基金合同、基金招募说明书相符\nC. 该材料应当含有明确的风险提示和警示性文字\nD. 基金公司向公众分发、公布的宣传材料应与提供给销售机构的材料一致",
            "answer": "D",
            "explain": "本题考查宣传推介材料审批报备流程。A选项表述正确，督察长应对基金宣传推介材料出具合规意见，报证监局批准后方可宣传。"
        },
        {
            "title": "以下属于基金公司合规管理活动范畴的有（　　）。",
            "question": "A. I、III、IV\nB. II、III\nC. I、II、IV\nD. I、II、III、IV",
            "questions": "I. 制定和执行合规管理制度<br>II. 建立合规管理机制<br>III. 执行基金会计核算制度<br>IV. 防范合规风险",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于基金管理人的内部治理结构，以下表述错误的是（　　）。",
            "question": "A. 股东会、董事会、监事会和高级管理人员职责权限要明确\nB. 公司监事与高级管理人员应相互独立\nC. 基金管理人股东会与董事会职能可以重叠以最小化治理成本\nD. 基金管理人应当建立良好的内部治理机构",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于公募基金管理公司基金交易业务控制的主要内容，以下表述正确的是（　　）。",
            "question": "A. II、IV\nB. II、III\nC. I、III\nD. I、II",
            "questions": "I. 公司对基金交易实行集中交易制度，基金经理应直接向交易员下达投资指令<br>II. 公司应建立交易监测系统、预警系统和交易反馈系统，完善相关的安全设施<br>III. 公司应执行公平的交易分配制度，确保不同投资者的利益能够得到公平对待<br>IV. 公司应建立完善的交易记录制度，每周核对投资组合列表并存档保管",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金行政监管应当具有全面性，以下不属于行政监管范围的是（　　）。",
            "question": "A. 基金机构从业人员的资格和行为\nB. 各种基金机构的设立、变更和终止\nC. 为基金机构提供法律服务的律师事务所\nD. 基金机构对证券投资中市场趋势研判的正确性",
            "answer": "D",
            "explain": ""
        }, {
            "title": "关于金融市场的构成要素及结构，以下表述正确的是（　　）。",
            "question": "A. I、II\nB. III、IV\nC. II、III\nD. I、IV",
            "questions": "I. 金融市场的构成要素包括：市场参与者、金融工具、金融交易的组织方式<br>II. 中央银行是金融市场上主要的资金供给者，是市场的最大参与者<br>III. 我国典型的场外交易市场有银行间债券市场、全国中小企业股份转让系统、债券柜台交易市场等<br>IV. 目前场内市场与场外市场之间的截然划分已经不复存在，出现了多层次的证券市场结构",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金托管人，以下说法正确的是（　　）。",
            "question": "A. 基金托管人与基金管理人可以为同一机构\nB. 基金托管银行的从业人员资格不同于其他基金托管人，由中国人民银行负责认定\nC. 基金托管人托管部门的高级管理人员的任职资格要求，适用法律法规对基金管理人相关人员的规定\nD. 基金管理人可以持有基金托管人股份",
            "answer": "C",
            "explain": "本题考查基金托管人的概念。A选项、D选项说法错误，《证券投资基金法》规定，基金资产必须由独立于管理人的托管人保管，基金托管人负责基金资产保管、基金资金清算、会计复核、对基金投资运作的监督等。因此，基金托管人与基金管理人不可以是同一机构，互相不可以持有股份。"
        },
        {
            "title": "张三是某基金管理公司研究员，下列行为中符合诚实守信职业道德要求的是（　　）。",
            "question": "A. 张三想研究上市航空公司的盈利情况，通过某上市石油公司的高管了解其对国际石油市场价格走势的预测和判断\nB. 张三在饭局上了解到某上市公司有*10送10*股利分配的预案，认为自己不宜进行股票交易，但告诉同学让其买入该股票\nC. 张三获悉某上市公司尚未公开发布的大比例分红预案，立即撰写研究报告，建议买入该股票\nD. 张三在交易日午间从券商研究员处听到某上市公司业绩变脸，立即告诉基金经理让其在午后一开盘就卖出",
            "answer": "A",
            "explain": "本题考查诚实守信的基本要求。诚实守信要求基金从业人员不得欺诈客户，在证券投资活动中不得有内幕交易和操纵市场行为，对于同行不得进行不正当竞争。B、C、D项存在内幕交易合操纵市场行为。"
        },
        {
            "title": "关于基金管理人管理层的合规责任，以下表述正确的是（　　）。",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II\nD. I、II、IV",
            "questions": "I. 建立健全合规管理组织架构<br>II. 配备充足、适当的合规管理人员，并提供必要的支持和保障<br>III. 发现违法违规行为及时报告和整改<br>IV. 审批合规管理的基本制度",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金公司运用基金资产买卖公司股东发行的证券这类关联交易，不正确的做法是（　　）。",
            "question": "A. 只要交易价格公允，则不需要做任何控制\nB. 判断是否存在利益输送的情况\nC. 履行法定的信息披露义务\nD. 遵循基金份额持有人利益优先的原则",
            "answer": "A",
            "explain": "本题考查合规检查的内容。重大关联交易的执行情况。检查基金管理人运用基金财产买卖基金管理人、基金托管人及其控股股东、实际控制人或者与其有其他重大利害关系的公司发行的证券或承销期内承销的证券，或者从事其他重大关联交易的，是否遵循基金份额持有人利益优先的原则（D选项），是否存在利益输送的情况（B选项），是否履行信息披露义务（C选项）等。B、C、D选项均正确。"
        },
        {
            "title": "甲的好友乙在一家私募基金管理公司从事投资管理工作，甲通过乙的微信朋友圈得知乙公司正在推介一款自己管理的基金产品，目乙已经以自有资金购买了100万元该基金产品。甲打电话询问乙，得知单个投资人最少投资额需要100万元，但甲手头只有60万元。乙建议甲找其他人一起凌齐100万元进行联合投资，后来甲找到同事内和丁，丙只有15万元，丁只有10万元。甲将凌齐的85万元转账给了乙，乙自己出资65万元，以自己的名义购买。<br>(1) 在以上案例中符合合格基金产品条件的人员是（　　）。",
            "question": "A. 甲\nB. 乙\nC. 丙\nD. 丁",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "甲的好友乙在一家私募基金管理公司从事投资管理工作，甲通过乙的微信朋友圈得知乙公司正在推介一款自己管理的基金产品，目乙已经以自有资金购买了100万元该基金产品。甲打电话询问乙，得知单个投资人最少投资额需要100万元，但甲手头只有60万元。乙建议甲找其他人一起凌齐100万元进行联合投资，后来甲找到同事内和丁，丙只有15万元，丁只有10万元。甲将凌齐的85万元转账给了乙，乙自己出资65万元，以自己的名义购买。<br>(2) 本案例中属于违规行为的是（　　）。",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、III、IV\nD. II、III、IV",
            "questions": "I. 乙通过微信朋友圈推介基金产品<br>II. 乙购买100万元基金产品<br>III. 甲乙丙丁凑齐150万元购买基金<br>IV. 乙用凑齐的资金以自己的名义购买150万元基金产品",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "甲的好友乙在一家私募基金管理公司从事投资管理工作，甲通过乙的微信朋友圈得知乙公司正在推介一款自己管理的基金产品，目乙已经以自有资金购买了100万元该基金产品。甲打电话询问乙，得知单个投资人最少投资额需要100万元，但甲手头只有60万元。乙建议甲找其他人一起凌齐100万元进行联合投资，后来甲找到同事内和丁，丙只有15万元，丁只有10万元。甲将凌齐的85万元转账给了乙，乙自己出资65万元，以自己的名义购买。<br>(3) 本案例的违规行为主要体现在（　　）。",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、III、IV\nD. II、III、IV",
            "questions": "I. 非法汇集他人资金<br>II. 违反规定向合格投资人以外的个人募集资金<br>III. 向不特定的对象宣传推介基金产品<br>IV. 违规接受低于最低限额的申购",
            "answer": "A",
            "explain": ""
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/flfg-2.js